module.exports = __webpack_public_path__ + "img/nodejs_96.75f504e4.png";